export default __webpack_public_path__ + "static/media/background.ddae9135.jpeg";